/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { V as Variants } from './constants-c94b83bd.js';

const DHL_ALERT_VARIANTS = {
    PRIMARY: Variants.primary,
    SECONDARY: Variants.secondary,
};
const DHL_ALERT_TYPE = {
    ERROR: Variants.error,
    SUCCESS: Variants.success,
    WARN: Variants.warn,
    NOTE: Variants.note,
};
const DHL_ALERT = {
    TYPE: DHL_ALERT_TYPE,
    VARIANT: DHL_ALERT_VARIANTS,
};

export { DHL_ALERT as D };

//# sourceMappingURL=constants-70441acf.js.map